import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllLeaves() {
  return (
    <ModulePlaceholderList
      title="All leave requests"
      newPath="/panel/leaves/new"
      newLabel="New leave request"
    />
  );
}
